import { z } from "zod";

export const linkedinSchema = z.object({
    link: z.string().min(1),
});

export type Linkedin = z.infer<typeof linkedinSchema>;
